import { useState, useEffect } from 'react'
import { legalService } from '@services/api/legal'
import LegalLayout from '@components/marketing/LegalLayout'

// Repli : contenu statique par défaut si aucune version n'est éditée depuis le back-office
const DefaultTerms = () => (
  <>
    <h2>1. Acceptation des conditions</h2>
    <p>
      En accédant et en utilisant la plateforme KUDHI, vous acceptez d&apos;être lié par ces Conditions
      Générales d&apos;Utilisation. Si vous n&apos;acceptez pas ces conditions, veuillez ne pas utiliser nos services.
    </p>

    <h2>2. Description du service</h2>
    <p>KUDHI est une plateforme de mise en relation en ligne qui permet aux utilisateurs de :</p>
    <ul>
      <li>Mettre en relation vendeurs et acheteurs</li>
      <li>Connecter entreprises et particuliers</li>
      <li>Publier des annonces de produits et services</li>
      <li>Rechercher et consulter des annonces</li>
      <li>Communiquer directement avec les autres utilisateurs</li>
      <li>Gérer leur profil et leurs publications</li>
    </ul>
    <p>KUDHI agit uniquement comme plateforme de mise en relation et ne participe pas aux transactions entre utilisateurs.</p>

    <h2>3. Compte utilisateur</h2>
    <h3>3.1 Inscription</h3>
    <ul>
      <li>Vous devez avoir au moins 18 ans pour créer un compte</li>
      <li>Vous devez fournir des informations exactes et à jour</li>
      <li>Vous êtes responsable de la confidentialité de votre mot de passe</li>
      <li>Un compte par utilisateur est autorisé</li>
    </ul>
    <h3>3.2 Suspension et résiliation</h3>
    <p>
      Nous nous réservons le droit de suspendre ou résilier votre compte en cas de violation
      de ces conditions, d&apos;activité frauduleuse ou de comportement inapproprié.
    </p>

    <h2>4. Publication d&apos;annonces</h2>
    <h3>4.1 Contenu autorisé</h3>
    <p>Vous pouvez publier des annonces pour :</p>
    <ul>
      <li>Produits d&apos;occasion ou neufs légaux</li>
      <li>Services légaux et autorisés</li>
      <li>Biens immobiliers</li>
      <li>Véhicules avec documents en règle</li>
    </ul>
    <h3>4.2 Contenu interdit</h3>
    <p>Il est strictement interdit de publier :</p>
    <ul>
      <li>Produits contrefaits ou volés</li>
      <li>Armes, drogues ou substances illégales</li>
      <li>Contenu pornographique, violent ou haineux</li>
      <li>Fausses annonces ou escroqueries</li>
      <li>Animaux protégés ou interdits</li>
      <li>Médicaments sans autorisation</li>
      <li>Services financiers non réglementés</li>
    </ul>
    <h3>4.3 Responsabilité du contenu</h3>
    <p>
      Vous êtes seul responsable du contenu de vos annonces. Vous garantissez que vos annonces
      sont conformes aux lois en vigueur et ne violent aucun droit de propriété intellectuelle.
    </p>

    <h2>5. Transactions entre utilisateurs</h2>
    <p>KUDHI n&apos;est pas partie prenante des transactions entre acheteurs et vendeurs. Nous ne sommes pas responsables de :</p>
    <ul>
      <li>La qualité, la sécurité ou la légalité des produits</li>
      <li>La véracité des annonces</li>
      <li>La capacité des vendeurs à vendre</li>
      <li>La capacité des acheteurs à payer</li>
      <li>Les litiges entre utilisateurs</li>
    </ul>
    <blockquote>
      <strong>Important :</strong> nous recommandons fortement de rencontrer les vendeurs en personne et
      d&apos;inspecter les produits avant tout paiement.
    </blockquote>

    <h2>6. Propriété intellectuelle</h2>
    <p>
      Tous les éléments de la plateforme KUDHI (logo, design, code, contenu) sont protégés par
      les droits de propriété intellectuelle. Vous ne pouvez pas :
    </p>
    <ul>
      <li>Copier, modifier ou distribuer notre contenu sans autorisation</li>
      <li>Utiliser notre marque ou logo sans permission écrite</li>
      <li>Créer des œuvres dérivées de notre plateforme</li>
      <li>Extraire des données de manière automatisée (scraping)</li>
    </ul>

    <h2>7. Limitation de responsabilité</h2>
    <p>Dans les limites permises par la loi, KUDHI ne sera pas responsable de :</p>
    <ul>
      <li>Pertes directes ou indirectes résultant de l&apos;utilisation de la plateforme</li>
      <li>Interruptions de service ou erreurs techniques</li>
      <li>Perte de données ou d&apos;informations</li>
      <li>Actions d&apos;autres utilisateurs</li>
      <li>Contenu publié par les utilisateurs</li>
    </ul>

    <h2>8. Frais et paiements</h2>
    <p>L&apos;utilisation de base de KUDHI est gratuite. Des frais peuvent s&apos;appliquer pour :</p>
    <ul>
      <li>Services premium (mise en avant d&apos;annonces)</li>
      <li>Bannières publicitaires</li>
      <li>Fonctionnalités avancées</li>
    </ul>
    <p>Les prix sont indiqués en Francs CFA (XOF) et peuvent être modifiés à tout moment.</p>

    <h2>9. Conduite des utilisateurs</h2>
    <p>Vous vous engagez à :</p>
    <ul>
      <li>Respecter les lois ivoiriennes et internationales</li>
      <li>Traiter les autres utilisateurs avec respect</li>
      <li>Ne pas harceler, menacer ou intimider</li>
      <li>Ne pas spammer ou envoyer de messages non sollicités</li>
      <li>Ne pas créer de faux comptes ou usurper l&apos;identité d&apos;autrui</li>
      <li>Signaler tout contenu ou comportement inapproprié</li>
    </ul>

    <h2>10. Modifications des conditions</h2>
    <p>
      Nous nous réservons le droit de modifier ces conditions à tout moment. Les modifications
      importantes vous seront notifiées par email ou via la plateforme. Votre utilisation continue
      après modification constitue votre acceptation des nouvelles conditions.
    </p>

    <h2>11. Loi applicable et juridiction</h2>
    <p>
      Ces conditions sont régies par les lois de la République de Côte d&apos;Ivoire. Tout litige sera soumis
      à la juridiction exclusive des tribunaux d&apos;Abidjan.
    </p>

    <h2>12. Contact</h2>
    <p>Pour toute question concernant ces conditions, contactez-nous :</p>
    <ul>
      <li><strong>Email :</strong> legal@kudhi.net</li>
      <li><strong>Téléphone :</strong> +225 05 06 76 77 17</li>
      <li><strong>Adresse :</strong> Grand Bassam, Côte d&apos;Ivoire</li>
    </ul>

    <blockquote>
      En utilisant KUDHI, vous reconnaissez avoir lu, compris et accepté ces Conditions Générales d&apos;Utilisation.
      <br />Date d&apos;effet : 26 novembre 2025
    </blockquote>
  </>
)

function TermsPage() {
  const [page, setPage] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    legalService.getPublic('cgu')
      .then(res => { if (res.success) setPage(res.data) })
      .catch(() => {})
      .finally(() => setLoading(false))
  }, [])

  return (
    <LegalLayout
      badge="Règles d'utilisation"
      title={page?.title || 'Conditions générales d\'utilisation'}
      updatedAt={page?.content ? page.updated_at : '2025-11-26'}
      loading={loading}
      html={page?.content}
      related={{ to: '/privacy', label: 'Politique de confidentialité' }}
    >
      <DefaultTerms />
    </LegalLayout>
  )
}

export default TermsPage
